import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Subject from '@/views/service/components/subject-select.vue';
import PageTitle from '@/components/page-title.vue';
import IframeWeb from '@/views/iframe-server';
import ErrorTips from './components/error-tips.vue';
import MaskLoading from '@/components/mask-loading.vue';
import { changeURLSearch } from '@/utils/tools';
import { getUserInfoDetail } from '@/api/login';
import { mapGetters } from 'vuex';
export default {
  name: 'Service',
  components: {
    Subject: Subject,
    PageTitle: PageTitle,
    IframeWeb: IframeWeb,
    ErrorTips: ErrorTips,
    MaskLoading: MaskLoading
  },
  data: function data() {
    var url = this.$route.query.url;
    var urlParams = new URL(url);
    var serachParams = new URLSearchParams(urlParams.search);
    var subject = +serachParams.get('subjectId');
    return {
      url: url,
      subject: subject,
      showErrorTips: false,
      fullscreenMode: false,
      // 学科切换的次数,后端在是错题本时不返回subjectId, 服务项通信routeChange又把subjectId加在url上,导致点击两次才返回,所以count改为1
      // url.includes('/answer/') 从视频那返回时subject有为空的情况
      count: subject > 0 || url.includes('/answer/') ? 0 : 1
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['subjectGetters', 'studyBindSuccess', 'serviceTitle', 'maskLoadingVisible'])), {}, {
    // 兼容URL不存在subject的情况
    strongSubject: function strongSubject() {
      return this.subject && this.subject > 0 ? this.subject : this.subjectGetters;
    }
  }),
  watch: {
    '$route.query.url': function $routeQueryUrl(val) {
      // 如果是进入到查看笔记页面那么count变成-1
      if (val.includes('reviewNoteDetail')) {
        this.count = 1;
      }

      this.url = val;
    },
    subjectGetters: {
      handler: function handler(val) {
        // 改变学科的方式有两种，一种是通过本页面的学科切换，另外一种是输入页码，每次改变都记录改变的数量
        this.count++;
        this.subject = val;
        this.$store.dispatch('setSubject', val);
        this.url = changeURLSearch(this.url, 'subjectId', val);
      },
      immediate: true
    },
    studyBindSuccess: function studyBindSuccess() {
      // 监听绑定自学宝成功
      var getSubject = this.$refs['subject'].getSubjectList;
      typeof getSubject === 'function' && getSubject();
    }
  },
  created: function created() {
    window.addEventListener('message', this.getMessageInfo);
  },
  methods: {
    switchSubject: function switchSubject(code) {
      if (typeof code !== 'number') {
        return;
      }

      this.subject = code;
      this.$store.dispatch('setSubject', code);
    },
    getUserName: function getUserName() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var user, params, _yield$getUserInfoDet, status, data, name, avaterUrl;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                user = JSON.parse(localStorage.getItem('userInfo'));
                params = {
                  uid: user.uid
                };
                _context.next = 4;
                return getUserInfoDetail(params);

              case 4:
                _yield$getUserInfoDet = _context.sent;
                status = _yield$getUserInfoDet.status;
                data = _yield$getUserInfoDet.data;

                if (status === 1 && data) {
                  name = data.name, avaterUrl = data.avaterUrl;

                  _this.$store.dispatch('setUsername', name);

                  _this.$store.dispatch('setUserAvatar', avaterUrl);
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    goBack: function goBack() {
      console.log(this.count); // 防止出现0的时候跳不出去

      var step = this.count === 0 ? -1 : -this.count;
      this.$router.go(step);
      this.count = 0;
    },
    // 关闭提示弹框
    closeTips: function closeTips() {
      this.showErrorTips = false;
    },
    getMessageInfo: function getMessageInfo(_ref) {
      var data = _ref.data;

      if ((data === null || data === void 0 ? void 0 : data.eventName) === 'ShowErrorTips') {
        // 展示选错题的引导页
        this.showErrorTips = true;
      } else if ((data === null || data === void 0 ? void 0 : data.eventName) === 'changeFullscreenMode') {
        // 设置图谱全屏模式
        this.fullscreenMode = data === null || data === void 0 ? void 0 : data.value;
      } else if ((data === null || data === void 0 ? void 0 : data.eventName) === 'setFullScreen') {
        // 设置视频全屏模式
        this.fullscreenMode = data === null || data === void 0 ? void 0 : data.fullScreen;
      }
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('setServicePageTitle', {
      'showSubject': false,
      'title': ''
    });
    next();
  }
};